import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {NbTooltipDirective} from '@nebular/theme';

@Component({
    selector: 'pv-no-address-warning',
    templateUrl: './no-address-warning.component.html',
    standalone: false
})
export class NoAddressWarningComponent {
  @ViewChildren(NbTooltipDirective) globalTooltipDirective: QueryList<NbTooltipDirective>;

  @Input() clickShouldClose: boolean;

  constructor() { }

  clicked() {
    if (this.clickShouldClose) {
      this.globalTooltipDirective.forEach(tooltip => tooltip.hide());
    }
  }
}
